import { createContext, useContext } from "react";
import { IApiClient } from "../shared/ApiClient";

const ApiClientContext = createContext<IApiClient | undefined>(undefined);

const useApiClient = (): IApiClient => {
  return useContext(ApiClientContext) as IApiClient;
};

interface ApiClientProviderProps {
  value: IApiClient;
  children: JSX.Element;
}

const ApiClientProvider = ({
  value,
  children,
}: ApiClientProviderProps): JSX.Element => {
  return (
    <ApiClientContext.Provider value={value}>
      {children}
    </ApiClientContext.Provider>
  );
};

export { ApiClientProvider, useApiClient };
